import DataDogLogo from "@modules/assets/settings/DataDogLogo.svg"
import { LogDrainProvider } from "@modules/graphql/types"
import { logDrainIntegration } from "@modules/locales/default"

export const logDrainVendorNames: Record<string, string> = {
  DATADOG: `Datadog`,
}

export const logDrainVendorLogo: Record<string, string> = {
  DATADOG: DataDogLogo,
}

export const logDrainConfigRequiredFields: Record<
  LogDrainProvider,
  string[]
> = {
  [LogDrainProvider.Datadog]: [`region`, `apiKey`],
}

export const logDrainConfigLabels: Record<
  LogDrainProvider,
  { [k: string]: string }
> = {
  [LogDrainProvider.Datadog]: {
    apiKey: logDrainIntegration.morphemes.apiKey,
    region: logDrainIntegration.morphemes.region,
  },
}
